module.exports = __webpack_public_path__ + "c01c4d5843c84b659a4af1b47dc401d7.jpg";